<template>
  <v-container fill-height fluid pa-0>
    <v-layout column>
      <v-img
        :height="`${this.windowHeight}`"
        :src="require('@/assets/background/2.jpg')">
        <v-container fill-height fluid style="background: #0000006f">
          <v-layout align-center justify-center>
            <v-card class="text-xs-center white--text" color="transparent" flat height="50%" width="80%">
              <v-card-text>
                <span class="display-2 font-weight-black">{{ $t('welcomeTitle') }}</span><br/>
              </v-card-text>
              <v-card-text class="mt-2">
                <P class="subheading font-weight-bold">{{ $t('welcomeMsg') }}</P>
              </v-card-text>
              <v-card-text class="mt-4">
                <v-btn color="grey lighten-3" large>
                  <span class="font-weight-bold"> {{ $t('welcomeBtn') }} </span>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-container>
      </v-img>

      <!-- Product Section -->
      <v-card :height="`${this.secondHeight}`" width="100%" color="grey lighten-4" flat>
        <v-container fill-height fluid pa-0>
          <v-layout align-center justify-center column>
            <v-card-text class="text-xs-center">
              <p class="display-2 mb-3 black--font font-weight-bold"> {{ $t('productTitle') }} </p>
            </v-card-text>
            <v-card-text style="text-align:justify;">
              <v-container fill-height fluid>
                <v-layout>
                  <v-flex class="text-xs-center pl-5 pr-5"
                    v-for="item in products" :key="item.id"
                    xs6 sm6 md3 lg3>
                    <v-card color="transparent" flat transition>
                      <v-layout align-center justify-center>
                        <v-card color="transparent" flat width="30%">
                          <v-img aspect-ratio="1"
                            :src="require('@/assets/icons/'+item.image)"></v-img>
                        </v-card>
                      </v-layout>
                      <v-card-text class="font-weight-bold">
                        {{ item.title }}
                      </v-card-text>
                      <v-card-text class="pt-0">
                        <p>{{ item.content }}</p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-btn color="grey darken-4" dark large>
                <span class="font-weight-bold"> {{ $t('productBtn') }} </span>
              </v-btn>
            </v-card-text>
          </v-layout>
        </v-container>
      </v-card>

      <!-- About Section -->
      <v-card width="100%" color="transparent" flat>
        <v-parallax
          :height="`${this.secondHeight}`"
          :src="require('@/assets/background/9.jpg')"
          style="padding: 0px">
          <v-container fill-height fluid pa-0 style="background: #ffffffaa">
            <v-layout align-center justify-center>
              <v-card width="60%" height="80%" color="transparent" flat>
                <v-card-text class="text-xs-center">
                  <p class="display-2 mb-3 black--font font-weight-black"> {{ $t('aboutTitle') }} </p>
                </v-card-text>
                <v-card-text style="text-align:justify;">
                  <p class="subheading" v-html="$t('aboutParagraph')"></p>
                </v-card-text>
                <v-card-actions class="pa-0">
                  <v-layout align-center justify-center>
                    <v-btn color="grey darken-4" dark large>
                      <span class="font-weight-bold"> {{ $t('aboutBtn') }} </span>
                    </v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-layout>
          </v-container>
        </v-parallax>
      </v-card>

      <!-- Work Section -->
      <v-card width="100%" color="grey lighten-4" flat>
        <v-container fill-height fluid pa-0>
          <v-layout align-center justify-center column>
            <v-card-text class="text-xs-center mt-5">
              <p class="display-2 mb-3 black--font font-weight-black"> {{ $t('worksTitle') }} </p>
              <p> {{ $t('worksStatement') }} </p>
            </v-card-text>
            <v-card-text style="text-align:justify;">
              <v-container fill-height fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex class="text-xs-center"
                    v-for="item in works" :key="item.id"
                    xs6 sm4 md3 lg3>
                    <v-hover>
                      <v-img aspect-ratio="1" slot-scope="{hover}"
                        :src="require('@/assets/background/'+item.image)">
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out v-card--reveal text-xs-center white--text"
                            style="height: 100%; background: #000000aa">
                            <v-layout column>
                              <v-card-text class="pb-2">
                                <span class="subheading font-weight-bold">{{item.title}}</span>
                              </v-card-text>
                              <v-card-text class="pt-0">
                                <span class="body-2">{{item.info}}</span>
                              </v-card-text>
                            </v-layout>
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-layout>
        </v-container>
      </v-card>

      <!-- Contact Section -->
      <v-card :height="`${this.secondHeight}`" color="transparent" flat>
        <v-img
          height="100%"
          :src="require('@/assets/background/13.jpg')">
          <v-container fill-height fluid pa-0 style="background: #000000aa">
            <v-layout align-center justify-center>
              <v-card width="40%" height="60%" color="transparent" flat>
                <v-card-text class="text-xs-center">
                  <p class="display-2 mb-3 white--text font-weight-black"> {{ $t('contactTitle') }} </p>
                </v-card-text>
                <v-card-text class="white--text subheading font-weight-bold" style="text-align:center;">
                  <p class="mb-0">263, Jalan Damai 4/2,</p>
                  <p class="mb-0">Taman Damai 09400,</p>
                  <p>Padang Serai, Kedah.</p>
                  <p>INFO@MYSITE.COM</p>
                  <p>TEL: 123-456-7890</p>
                </v-card-text>
              </v-card>
               <v-card width="40%" color="transparent" flat>
                <v-card-text class="white--text" style="text-align:center;">
                  <v-form ref="contactForm">
                    <v-text-field dark
                      v-model="inputName"
                      :label="$t('contactFormName')"
                      :rules="inputRules"
                      color="light-blue lighten-3"/>
                    <v-text-field dark
                      v-model="inputEmail"
                      :label="$t('contactFormEmail')"
                      :rules="inputRules"
                      color="light-blue lighten-3"/>
                    <v-text-field dark
                      v-model="inputSubject"
                      :label="$t('contactFormSubject')"
                      :rules="inputRules"
                      color="light-blue lighten-3"/>
                    <v-textarea dark
                      v-model="inputMessage"
                      :label="$t('contactFormMessage')" counter="200"
                      :rules="inputRules"
                      color="light-blue lighten-3">
                    </v-textarea>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pa-0">
                  <v-layout align-center justify-center>
                    <v-btn color="grey lighten-4" large @click="submitForm()" :loading="submitLoading">
                      <span class="font-weight-bold"> {{ $t('contactBtn') }} </span>
                    </v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-layout>
          </v-container>
        </v-img>
      </v-card>
      <v-snackbar
        class="mb-5"
        v-model="snackbar.value"
        :color="snackbar.color"
        :timeout="snackbar.timeout" >
        {{ snackbar.text }}
        <v-btn small dark flat @click="snackbar.value = false"> Close </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      windowHeight: 1000,
      secondHeight: 500,
      windowWidth: 500,
      gradient: 'to top right, rgba(63,81,181, .7), rgba(25,32,72, .7)',
      products: [
        { id: 1, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle1'), content: this.$i18n.t('productAttributeDescription1') },
        { id: 2, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle2'), content: this.$i18n.t('productAttributeDescription2') },
        { id: 3, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle3'), content: this.$i18n.t('productAttributeDescription3') },
        { id: 4, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle4'), content: this.$i18n.t('productAttributeDescription4') }
      ],
      works: [
        { id: 1, image: '8.jpg', title: this.$i18n.t('worksImageTitle1'), info: this.$i18n.t('worksImageDescription1') },
        { id: 2, image: '9.jpg', title: this.$i18n.t('worksImageTitle2'), info: this.$i18n.t('worksImageDescription2') },
        { id: 3, image: '10.jpg', title: this.$i18n.t('worksImageTitle3'), info: this.$i18n.t('worksImageDescription3') },
        { id: 4, image: '11.jpg', title: this.$i18n.t('worksImageTitle4'), info: this.$i18n.t('worksImageDescription4') },
        { id: 5, image: '13.jpg', title: this.$i18n.t('worksImageTitle5'), info: this.$i18n.t('worksImageDescription5') },
        { id: 6, image: '4.jpg', title: this.$i18n.t('worksImageTitle6'), info: this.$i18n.t('worksImageDescription6') },
        { id: 7, image: '7.jpg', title: this.$i18n.t('worksImageTitle7'), info: this.$i18n.t('worksImageDescription7') },
        { id: 8, image: '3.jpg', title: this.$i18n.t('worksImageTitle8'), info: this.$i18n.t('worksImageDescription8') }
      ],
      inputName: '',
      inputEmail: '',
      inputSubject: '',
      inputMessage: '',
      submitLoading: false,
      inputRules: [
        v => !!v || this.$i18n.t('contactValidate')
      ],
      snackbar: {
        value: false,
        color: 'success',
        timeout: 6000,
        text: '',
      },
    }
  },

  methods: {
    ...mapActions('contact', ['storeFeedback']),

    setSize () {
      this.windowHeight = window.innerHeight
      this.secondHeight = this.windowHeight * 0.75
      this.thirdHeight = this.windowHeight * 0.3
      this.windowWidth = window.innerWidth
    },
    submitForm () {
      if (this.$refs.contactForm.validate()) {
        this.submitLoading = true
        let form = {
          email: this.inputEmail,
          name: this.inputName,
          subject: this.inputSubject,
          message: this.inputMessage
        }
        this.storeFeedback(form)
          .then(response => {
            this.successStatus()
          }).catch(error => {
            this.failStatus()
            console.log(error)
          })
      }
    },

    successStatus() {
      this.submitLoading = false
      this.snackbar.text = "Contact sent successfully."
      this.snackbar.color = "success"
      this.snackbar.value = true
      this.$refs.contactForm.reset()
      this.inputName = ''
      this.inputEmail = ''
      this.inputSubject = ''
      this.inputMessage = ''
    },

    failStatus() {
      this.submitLoading = false
      this.snackbar.text = "Please enter all details or something went wrong."
      this.snackbar.color = "error"
      this.snackbar.value = true
    }
  },

  mounted () {
    this.setSize()
  }
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .9;
  position: absolute;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue